import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

import {
    AuthorizationService,
    DocumentService,
    EquipmentService,
    AssociationService,
    Document,
    DataArray,
    PresetService
} from './../../../../shared/index';

@Component({
    selector: 'documentselection',
    templateUrl: './documentselection.html',
    standalone: false
})

export class DocumentSelectionComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
    public selectedDocuments: DataArray<Document> = new DataArray<Document>(1);
    constructor(
        private _authorizationService: AuthorizationService,
        private _associationService: AssociationService,
        private _documentService: DocumentService,
        private _presetService: PresetService
    ) { }

    public dragDropped($event: any): void {
      this.clearSelectedDocuments();
  }

    public clearSelectedDocuments(): void {
        this.selectedDocuments.init();
        this._documentService.clearAll();
    }

    ngOnInit(): void {
        this.selectedDocuments.init();

        this.subscriptions.push(this._documentService.documentSelectedChange.subscribe((document: Document) => {
            if (document.Selected) {
                this.selectedDocuments.update(document, true);
            } else {
                this.selectedDocuments.delete(document);
            }
        }));

        this.subscriptions.push(this._presetService.presetSelectedChange.subscribe((data: any) => {
            if (data.ResetSelectedDocument) {
                this.selectedDocuments.init();
                for (let i = 0; i < data.PresetDocuments.length; i++) {
                    const doc: Document = $.extend(new Document(), data.PresetDocuments[i].Document);
                    doc.Selected = true;
                    this.selectedDocuments.insert(doc);
                }
            }
        }));

        this.subscriptions.push(this._presetService.presetSelectionReset.subscribe(() => {
            this.selectedDocuments.init();
        }));
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
